/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackupFileViewModel } from '../../models/backup-file-view-model';

export interface ListDatabaseBackups$Params {
}

export function ListDatabaseBackups(http: HttpClient, rootUrl: string, params?: ListDatabaseBackups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BackupFileViewModel>>> {
  const rb = new RequestBuilder(rootUrl, ListDatabaseBackups.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BackupFileViewModel>>;
    })
  );
}

ListDatabaseBackups.PATH = '/api/Developer/ListDatabaseBackups';
